import { type ReactElement } from 'react';

interface RecipeaseLogoProps {
	/** Set the name beside the mark. Off where the name is already said. */
	wordmark?: boolean;
	className?: string;
}

/**
 * The Recipease lockup, exactly as the design system's mocks draw it:
 *
 *   <div class="brand"><div class="mark">R</div><span class="heading">Recipease</span></div>
 *
 * The mark is a 26px square of `--spot` carrying a mono R in paper. It is set
 * as text, not drawn, so it renders in the same IBM Plex Mono as every figure
 * in the system and inherits the theme without a second asset. There is one
 * size; a bigger mark would be a second identity.
 */
function RecipeaseLogo({ wordmark = true, className }: RecipeaseLogoProps): ReactElement {
	return (
		<span className={className ? `brand ${className}` : 'brand'}>
			<span className='mark' aria-hidden='true'>R</span>
			{wordmark ? <span className='heading'>Recipease</span> : <span className='sr-only'>Recipease</span>}
		</span>
	);
}

export default RecipeaseLogo;
